import { NavBar } from "../Navbar/NavBar";
import axios from "axios";
import { React, Fragment, useState, useEffect } from "react";
import { Menu, Transition } from "@headlessui/react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./retail.css";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Select from "react-select";
import { useParams } from "react-router-dom";
import { useNavigate, Link } from "react-router-dom";
import { ClipLoader } from "react-spinners";
import Sidebar from "../Sidebar";

const ViewGridSingleId = () => {
  const [orders, setOrders] = useState([]);
  const [totalOrders, setTotalOrders] = useState(0);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const { grid_id } = useParams();

  const totalPages = Math.ceil(totalOrders / 10);

  useEffect(() => {
    const fetchOrders = async () => {
      const token = localStorage.getItem("token");
      try {
        const response = await axios.get(
          `/workflow/api/retailers/grids/${grid_id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (response.data.data) {
          setOrders(response.data.data); // Update this line
          console.log(response, "data is coming");
        }
      } catch (error) {
        console.error("Failed to fetch orders:", error);
      }
    };

    fetchOrders();
  }, [grid_id]);

  const formatDate = (dateString) => {
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    const nth = (d) => {
      if (d > 3 && d < 21) return "th";
      switch (d % 10) {
        case 1:
          return "st";
        case 2:
          return "nd";
        case 3:
          return "rd";
        default:
          return "th";
      }
    };

    const date = new Date(dateString);

    const day = date.getDate();
    const monthIndex = date.getMonth();
    const year = date.getFullYear();

    return `${day}${nth(day)} ${monthNames[monthIndex]} ${year}`;
  };

  const formatNumberWithCommas = (number) => {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  return (
    <div className="flex">
      <div className="mt-3 ml-8 builk-main ">
        {loading ? (
          <div className="fixed top-0 left-0 right-0 bottom-0 bg-gray-900 bg-opacity-50 flex items-center justify-center">
            <ClipLoader color="#4A1AC7" size={50} />
          </div>
        ) : null}
        {/*------------------------------------------- Tabs List Started --------------------------------------- */}
        <ToastContainer />

        {/*------------------------------------------- Tabs List Ended --------------------------------------- */}
        <div className="flex justify-end mt-20 gap-8">
          <nav
            className="flex text-gray-600 dark:text-gray-200 bg-gray-100 dark:bg-gray-900 w-full items-start p-2 space-y-4 rounded-md"
            aria-label="Breadcrumb"
          >
            <ol className="inline-flex items-center space-x-1 md:space-x-4 pt-3">
              <li className="inline-flex items-center">
                <Link
                  to="/bulkorder"
                  className="text-gray-600 dark:text-gray-200 inline-flex ml-1 md:ml-2 text-sm font-medium hover:underline"
                >
                  <svg
                    className="w-5 h-5 mr-2.5"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z"></path>
                  </svg>
                  Bulk Workflow
                </Link>
              </li>
              <li>
                <div className="flex items-center">
                  <span className="mx-2.5 text-gray-500 dark:text-gray-300">
                    /
                  </span>
                  <Link
                    to="/distributors-lead-retail"
                    className="text-gray-600 dark:text-gray-200 ml-1 md:ml-2 text-sm font-medium hover:underline"
                  >
                    Distributors Lead Retailer
                  </Link>
                </div>
              </li>
              <li aria-current="page">
                <div className="flex items-center">
                  <span className="mx-2.5 text-gray-500 dark:text-gray-300">
                    /
                  </span>
                  <span className="text-gray-600 dark:text-gray-200 ml-1 md:ml-2 text-sm font-medium hover:underline">
                    Grid No.{grid_id}
                  </span>
                </div>
              </li>
            </ol>
          </nav>
        </div>

        {/*------------------------------------------- Grid Lists Starts--------------------------------------- */}

        <div className="text-gray-500 ">
          <section className="fluid w-full  px-2">
            <div className="flex items-center justify-between"></div>
            <div className="flex flex-col mt-2 ">
              <div className="overflow-x-auto bg-cyan-500 shadow-lg shadow-cyan-500/50 ">
                <div className="inline-block min-w-full py-2 align-middle bg-cyan-500 shadow-lg shadow-cyan-500/50">
                  <div className="overflow-hidden border border-gray-200 dark:border-gray-700 md:rounded-lg bg-cyan-500 shadow-lg shadow-cyan-500/50">
                    <table className="min-w-full bg-cyan-500 shadow-lg shadow-cyan-500/50 ">
                      <thead className="bg-gray-50 dark:bg-gray-800 ">
                        <tr className="divide-x divide-gray-200">
                          <th
                            scope="col"
                            className="rounded-md bg-gray-900 py-3.5 px-4 text-lg font-normal text-center text-white dark:text-gray-800"
                          >
                            Order Id
                          </th>
                          <th
                            scope="col"
                            className="rounded-md bg-gray-900 py-3.5 px-4 text-lg font-normal text-center text-white dark:text-gray-800"
                          >
                            Retailer Grid Id
                          </th>
                          <th
                            scope="col"
                            className="rounded-md bg-gray-900 py-3.5 px-4 text-lg font-normal text-center text-white dark:text-gray-800"
                          >
                            Buyer Name
                          </th>
                          <th
                            scope="col"
                            className="rounded-md bg-gray-900 py-3.5 px-4 text-lg font-normal text-center text-white dark:text-gray-800"
                          >
                            Supplier Name
                          </th>
                          <th
                            scope="col"
                            className="rounded-md bg-gray-900 py-3.5 px-4 text-lg font-normal text-center text-white dark:text-gray-800"
                          >
                            Retailer Margin(%)
                          </th>
                        </tr>
                      </thead>

                      <tbody className="bg-white divide-y divide-gray-200 dark:divide-gray-700 dark:bg-gray-900">
                        {(orders || []).map((item, index) => (
                          <tr key={index} className="divide-x divide-gray-200">
                            <td className="py-4 px-4 whitespace-nowrap text-center">
                              <div className="flex items-center justify-center">
                                <div className="text-sm text-gray-500 dark:text-gray-300">
                                  {item.order_id}
                                </div>
                              </div>
                            </td>
                            <td className="px-12 py-4 whitespace-nowrap text-center">
                              <div className="text-sm text-gray-900 dark:text-white">
                                {item.retailer_grid_id}
                              </div>
                            </td>
                            <td className="px-4 py-4 whitespace-nowrap text-center">
                              {item.buyer_name}
                            </td>
                            <td className="px-4 py-4 whitespace-nowrap text-center">
                              {item.supplier_name}
                            </td>
                            <td className="px-4 py-4 whitespace-nowrap text-center">
                              <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
                                {item.retailer_margin}%
                              </span>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>

        {/*------------------------------------------- Grid List Ends --------------------------------------- */}
      </div>
    </div>
  );
};

export default ViewGridSingleId;
